var React = require('react');

function CreditCardInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.19995 12.8H28.8M6.39995 6.40002H25.6C27.3673 6.40002 28.8 7.83271 28.8 9.60002V22.4C28.8 24.1673 27.3673 25.6 25.6 25.6H6.39995C4.63264 25.6 3.19995 24.1673 3.19995 22.4V9.60002C3.19995 7.83271 4.63264 6.40002 6.39995 6.40002Z","stroke":"#EC5344","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CreditCardInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = CreditCardInline;

CreditCardInline.default = CreditCardInline;
